<template>
  <div class="page-wrapper">
    <div class="mb32">
      <Input style="width: 300px ;" v-model="ownerCondition" placeholder="按业主名称搜索" @keyup.enter.native="inputChange" ></Input>      
    </div>
    <table-list
      title="" :columns="columns" :data="dataList" :loading="loading" :total="total" :current="current" @change-page="changePage"
    >
    <Button class="mb16" type="primary" @click.stop="addPro" v-p="{api:'owner/save'}">添加业主</Button>
    </table-list>
    <pro-add :n="proAddN" @addsuccess="getOwnerList"></pro-add>
    <pro-update :n="n2"  :ownerId="updateownerId" @updatesuccess="getOwnerList"></pro-update>
  </div>

</template>
<script>
  import TableList from "components/TableList/index";
  import ProAdd from './components/ProAdd'
  import {ownerlist} from "../../../api/owner";
  import ProUpdate from './components/ProUpdate'
  import {getOwnerOtherInfo,ownerdelete} from "../../../api/owner";

  export default {
    name:'promanage1',  //不缓存
    components:{
      TableList,
      ProAdd,
      ProUpdate
    },
    data(){
      return {
        updateownerId:'',
        updateFormData:{},
        n2:0,
        columns:[
          {
            type:'index',
            width:60,
            align:'center'
          },
          {
            title:' '
          },
          {
            title: "收房合同号",
            key: "houseContractNos",
            align: "center",
            width:150,
            render:(h,params)=>{
              let length=params.row['houseContractNos'].length

              if(length>14){
                let show=params.row['houseContractNos'].slice(0,10)+'...'
                return h('span',{
                  attrs:{
                    title:params.row['houseContractNos']
                  }
                },show)
              }
              else{
                return h('span',{},params.row['houseContractNos'])

              }

            }
          },
          {
            title:' '
          },
          {
            title: "业主名称",
            key: "ownerName",
            align: "center",
            width:160,
            render:(h,param)=>{
              return h('a',{
                on:{
                  click:()=>{
                    let id=param.row['fid']
                    this.$router.push({ name: 'proinfo',params: {id}})
                  }
                }

              },param.row['ownerName'])

            }
          },
          {
            title:' '
          },
          {
            title: "组织机构代码/身份证",
            key: "key1",
            align: "center",
            width:160,
            render:(h,param)=>{
              if(param.row['ownerType']==1){  //企业类型
                return this.lookUpPublic(h,param,'ownerBusinessCode','show1')
              }
              else {
                return this.lookUpPublic(h,param,'ownerIdcard','show1')
              }
            }
          },
          {
            title:' '
          },
          {
            title: "法人/产权人",
            key: "ownerLegalRepresent",
            align: "center",
             width:120,
          },
          {
            title:' '
          },
          {
            title: "开户银行",
            key: "ownerBankName",
            align: "center",
            width:120,
          },
          {
            title:' '
          },
          {
            title: "银行账号",
            key: "key3",
            align: "center",
             width:160,
            render:(h,param)=>{
              return this.lookUpPublic(h,param,'ownerBankCard','show2')
            }
          },
          {
            title:' '
          },
          {
            title: "财务联系人",
            key: "financeUser",
            align: "center",
             width:100,
          },
          {
            title:' '
          },
          {
            title: "联系人电话",
            key: "key4",
            align: "center",
            width:120,
            render:(h,param)=>{
              return this.lookUpPublic(h,param,'financePhone','show3')
            }
          },
          {
            title:' '
          },
          {
            title: "经办人",
            key: "ownerOperatorName",
            align: "center",
             width:100,
          },
          {
            title:' '
          },
          {
            title: "操作",
            width:150,
            key: "action",
            align: "center",
            fixed:'right',
            render:(h,params)=>{
              return h(
                'div',{},[
                 h('Button',{
                   props: {
                     type: "primary",
                     size: "small"
                   },
                   directives:[
                     {
                       name:'p',
                       value:{
                         api:'owner/update'
                       }
                     }
                   ],
                   style:{
                     marginRight: "5px"
                   },
                   on:{
                     click:()=>{
                       this.updateownerId=params.row['fid']
                       this.n2++
                     }
                   }
                 },'修改'),
                  h('Button',{
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    directives:[
                      {
                        name:'p',
                        value:{
                          api:'owner/delete'
                        }
                      }
                    ],
                    on:{
                      click:()=>{
                        this.ownerdelete(params.row)

                      }
                    }
                  },'删除'),
                ]
              )
            }
          },
        ],
        dataList:[],
        loading:false,
        total:0,
        current:1,
        proAddN:0,
        page:1,
        limit:10,
        ownerCondition:'',
      }
    },
    methods:{
      inputChange(){
        this.current=1
        this.page=1
        this.dataList=[]
        this.getOwnerList()
      },
      ownerdelete(item){
        this.$Modal.confirm({
          // title:'',
          content:'<p>确认删除本条业主记录？</p>',
          onOk:()=>{
            let params={
              ownerId:item.fid
            }
            ownerdelete(params).then(res=>{
              this.$Message.success('业主记录删除成功')
              this.current=1
              this.page=1
              this.getOwnerList()
            }).catch(error=>{})
          }
        })
      },

      getOwnerList(){
        let params={
          page:this.page,
          limit:this.limit,
          ownerCondition:this.ownerCondition
        }
        ownerlist(params).then(res=>{
          this.total=res.data.total
          if(!res.data.townerVoList|| res.data.townerVoList.length==0){
            return
          }
          res.data.townerVoList.forEach(ele=>{
            ele['show1']=false
            ele['show2']=false
            ele['show3']=false
          })
          this.dataList=res.data.townerVoList
        }).catch(error=>{})
      },
      changePage(n){
        this.current=n
        this.page=n
        this.getOwnerList()

      },
      lookUpPublic(h,param,key,controlKey){
        return h(
          "a",{
            style:{
              display:param.row[key] ? 'inline-block' : 'none'
            },
            on:{
              click:()=>{
                param.row[controlKey]=true
              }
            }
          },param.row[controlKey]?param.row[key]:'查看'
        )
      },
      addPro(){
        this.proAddN++
      }
    },
    created(){
      this.getOwnerList()
    }
  }
</script>

<style scoped>
</style>
